import { classNames } from '../../utils/classNames';

function Tabs({ tabs, activeTab, onChange }) {
  return (
    <div>
      <div className="flex gap-1 border-b" role="tablist">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.id}
            onClick={() => onChange(tab.id)}
            className={classNames('relative px-4 py-3 text-sm font-medium transition after:absolute after:inset-x-0 after:bottom-[-1px] after:h-0.5', activeTab === tab.id ? 'text-primary-700 after:bg-primary-600' : 'text-content-muted after:bg-transparent hover:text-content-primary')}
          >
            {tab.label}
            {tab.count !== undefined && <span className="ml-2 rounded-full bg-slate-100 px-2 py-0.5 text-xs">{tab.count}</span>}
          </button>
        ))}
      </div>
      {tabs.map((tab) => activeTab === tab.id && (
        <div key={tab.id} role="tabpanel" className="py-4">{tab.content}</div>
      ))}
    </div>
  );
}

export default Tabs;
